import request from '@/utils/request'

const addShopCarts = (sku, num) => {
  return request({
    url: `/shop/carts/skus/${sku}`,
    data: num,
    method: 'post'
  })
}

const delShopCarts = (sku) => {
  return request({
    url: `/shop/carts/skus/${sku}`,
    method: 'delete'
  })
}

const modifyShopCartsNum = (sku, num) => {
  return request({
    url: `/shop/carts/skus/${sku}`,
    data: num,
    method: 'put'
  })
}
const modifyShopCartsCheck = (sku, checked) => {
  return request({
    url: `/shop/carts/skus/${sku}/checked`,
    data: checked,
    method: 'put'
  })
}

const getShopCarts = (params) => {
  return request({
    url: '/shop/carts/skus',
    params,
    method: 'get'
  })
}

const getStoreInfo = (id) => {
  return request({
    url: `/shop/stores/${id}`,
    method: 'get'
  })
}

export {
  addShopCarts, // 加入购物车
  delShopCarts, // 删除购物车商品
  modifyShopCartsNum, // 修改购物车商品数量
  modifyShopCartsCheck, // 修改购物车商品选中状态
  getShopCarts, // 查询购物车信息
  getStoreInfo
}
